import noop from 'lodash/noop';
import { createContext, PropsWithChildren, useCallback, useContext } from 'react';

import { segmentTrack } from '@/hooks/analytics/useTracking';

export enum ArtifactInstallSource {
  buildDistributionTestBuildDetailsPageDownloadArtifactModal = 'build_distribution_test_build_details_page_download_artifact_modal',
  installableArtifactDetailsPageDownloadArtifactModal = 'installable_artifact_details_page_download_artifact_modal',
}

export enum ArtifactDownloadSource {
  buildDistributionTestBuildDetailsPageHeader = 'build_distribution_test_build_details_page_header',
  buildDistributionTestBuildDetailsPageDownloadArtifactModal = 'build_distribution_test_build_details_page_download_artifact_modal',
  buildDetailsArtifactsTab = 'build_details_artifacts_tab',
  installableArtifactDetailsPageHeader = 'installable_artifact_details_page_header',
  installableArtifactDetailsPageDownloadArtifactModal = 'installable_artifact_details_page_download_artifact_modal',
  installableArtifactsPageTable = 'installable_artifacts_page_table',
}

type ArtifactTrackingFn = typeof segmentTrack;

type ArtifactTrackingProviderProps = PropsWithChildren<{
  appSlug?: string;
  artifactSlug?: string;
  buildSlug?: string;
  projectId?: string;
}>;

const Context = createContext<ArtifactTrackingFn>(noop);

// TODO: get rid of this context and use segmentTrack directly, because this is error prone
const ArtifactTrackingProvider = ({
  appSlug,
  artifactSlug,
  buildSlug,
  projectId,
  children,
}: ArtifactTrackingProviderProps) => {
  const artifactTrackingFn: ArtifactTrackingFn = useCallback(
    (event, properties) => {
      segmentTrack(event, {
        event_schema_version: 2.0,
        ...properties,
        app_slug: appSlug,
        artifact_slug: artifactSlug,
        build_slug: buildSlug,
        project_id: projectId,
      });
    },
    [appSlug, artifactSlug, buildSlug, projectId],
  );

  return <Context.Provider value={artifactTrackingFn}>{children}</Context.Provider>;
};

export const useArtifactTracking = () => useContext(Context);

export default ArtifactTrackingProvider;
